export const statuses = {
  LOADING: 'loading',
  DONE: 'done',
  FAILED: 'failed',
  DEFAULT: 'default',
}
